import { createFileRoute } from '@tanstack/react-router';
import { JourneysPage } from '@/components/journeys/JourneysPage.tsx';
import { journeysSearch } from '@/components/journeys/journeysSearch.ts';

export const Route = createFileRoute('/_app/journeys/')({
  validateSearch: journeysSearch,
  component: JourneysPage,
});
